import { render, staticRenderFns } from "./STEP4.vue?vue&type=template&id=75fabe1f&scoped=true&"
import script from "./STEP4.vue?vue&type=script&lang=js&"
export * from "./STEP4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fabe1f",
  null
  
)

export default component.exports